const getParam = (url: string, param: string): string | undefined => {
  const paramList = url.substr(1).split("&");
  for (const keyValue of paramList) {
    if (keyValue.split("=")[0] === param) {
      return keyValue.split("=")[1]; // Return first occurrence
    }
  }
  return undefined;
};

export const getUrlOrHashParam = (
  window: Window,
  param: string
): string | undefined => {
  // Url params > Hash params
  const searchParam = getParam(window.location.search, param);
  if (searchParam !== undefined) {
    return searchParam;
  }
  const hashParam = getParam(window.location.hash, param);
  if (hashParam !== undefined) {
    return hashParam;
  }
  return undefined;
};

export const parseNumericParam = (
  param: unknown,
  roundTo?: number
): number | undefined => {
  if (param === undefined) {
    return undefined;
  }

  const numericParam = Number(param);

  if (isNaN(numericParam)) {
    return numericParam;
  }

  if (roundTo) {
    const factor = Math.pow(10, roundTo);
    return Math.round((numericParam + Number.EPSILON) * factor) / factor;
  }

  return numericParam;
};
